import type { UserUuid } from "../identity";



export interface Medication {
	id: number;
	patient_id: UserUuid;
	medication_catalog_id?: number;
	medication_name: string;
	dosage: string;
	frequency: string;
	instructions?: string;
	start_date: Date;
	end_date?: Date;
	prescribed_by?: string;
	active: boolean;
	created_at: Date;
	updated_at: Date;
	details?: string | any; // JSON string or parsed object for additional medication details
	script_file_id?: string;
	script_uploaded_at?: string;
	script_uploaded_by?: UserUuid;
	script_status?: 'pending' | 'uploaded' | 'verified' | 'expired';
	script_notes?: string;
	script_type?: 'file' | 'escript';
	script_url?: string;
}


export const defaultMedication: Medication = {
	id: 0,
	patient_id: "",
	medication_name: "",
	dosage: "",
	frequency: "",
	instructions: "",
	start_date: new Date(),
	end_date: undefined,
	prescribed_by: "",
	active: true,
	created_at: new Date(),
	updated_at: new Date(),
	details: {}
};


export const SCRIPT_STATUS_CONFIG: Record<
    NonNullable<Medication['script_status']>,
    { label: string; color: string; tagColor: string }
> = {
    pending:  { label: 'Script Required',  color: '#d46b08', tagColor: 'warning' },
    uploaded: { label: 'Script Submitted', color: '#0958d9', tagColor: 'processing' },
    verified: { label: 'Script Verified',  color: '#389e0d', tagColor: 'success' },
    expired:  { label: 'Script Expired',   color: '#cf1322', tagColor: 'error' },
};